import { css } from '@emotion/css';
import { Button, ButtonProps, styled } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from 'atoms/Link';
import SideBar from 'molecules/SideBar';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { colors } from 'styles/colors';

import burger from 'assets/icons/burger.svg';
import logo from 'assets/icons/logo.svg';

const PageHeader = () => {
    const user = useSelector((state: RootState) => state.user.user);
    const matches = useMediaQuery('(min-width:580px)');
    const [state, setState] = useState(false);

    const ColorButton = styled(Button)<ButtonProps>(() => ({
        color: colors.primaryText,
        backgroundColor: colors.backgroundLight,
        width: '7.31rem',
        height: '2.31rem',
        fontSize: '16px',
        fontWeight: '400',
        fontFamily: 'Figtree',
        padding: '5px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: colors.backgroundLight,
        },
        borderRadius: '0.5rem',
        border: '1px solid white',
    }));

    return (
        <>
            {user && (
                <div
                    className={styles.headerPrivate}
                    onClick={() => {
                        if (state === true) {
                            setState(!state);
                        }
                    }}
                >
                    <SideBar isStateBarShown={state} setState={setState}></SideBar>
                    <div className={styles.logoBlock}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50}>
                            <image href={logo} width={50} height={50} />
                        </svg>
                    </div>
                    {matches === true && (
                        <div
                            className={styles.linkButtonsContainer}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                        >
                            <Link
                                underline="hover"
                                text="Tidslinje"
                                link="/time-line"
                                linkCustomStyle={styles.linkCustomStyle}
                            />
                            <Link
                                underline="hover"
                                text="Spørgeskemaer"
                                link="/questionnaries-list"
                                linkCustomStyle={styles.linkCustomStyle}
                            />
                            <Link
                                underline="hover"
                                text="Kostdagbog"
                                link="/fooddiary"
                                linkCustomStyle={styles.linkCustomStyle}
                            />
                        </div>
                    )}
                    <div className={styles.rightContent}>
                        {matches === true ? (
                            <ColorButton variant="contained" onClick={() => setState(true)}>
                                Min profil
                            </ColorButton>
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={30}
                                height={24.589}
                                onClick={() => setState(!state)}
                            >
                                <image href={burger} width={30} height={24.589} />
                            </svg>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    headerPrivate: css({
        width: '100%',
        height: '4.5rem',
        backgroundColor: colors.primary,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'absolute',
    }),
    linkButtonsContainer: css({
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '2.5rem',
        '@media (max-width: 427px)': {
            paddingLeft: '0.5rem',
        },
    }),
    rightContent: css({
        marginLeft: 'auto',
        marginRight: '2.5rem',
        '@media (max-width: 427px)': {
            marginRight: '1.5rem',
        },
    }),
    linkCustomStyle: css({
        marginRight: '1.75rem !important',
        fontFamily: 'Figtree !important',
        fontSize: '16px !important',
        fontStyle: 'normal !important',
        fontWeight: '400 !important',
        lineHeight: 'normal !important',
        color: colors.primaryTextLight + ' !important',
        '@media (max-width: 427px)': {
            marginRight: '1.31rem !important',
        },
    }),
    content: css({
        position: 'relative',
        marginTop: '2rem',
        marginBottom: '4rem',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        '@media (min-width: 800px)': {
            width: '50rem',
        },
    }),
    header: css({
        fontSize: '28px',
        fontWeight: '700',
        maxWidth: '200px',
        marginTop: '1rem',
    }),
    userRow: css({
        position: 'absolute',
        top: '0',
        left: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        '@media (max-width: 800px)': {
            left: 'calc(50% - 11rem)',
            flexDirection: 'column',
        },
    }),
    logoBlock: css({
        marginLeft: '1.25rem',
    }),
};

export default PageHeader;
